// activityCommService.js - API Service Layer for Activity & Communication Module

import axiosInstance from '../../../../utils/axiosInstance';

// ==================== TASK SERVICE ====================
export const taskService = {
  getAll: async (params = {}) => {
    const response = await axiosInstance.get('/api/activity/tasks', { params });
    return response.data;
  },

  getById: async (id) => {
    const response = await axiosInstance.get(`/api/activity/tasks/${id}`);
    return response.data;
  },

  getStats: async (params = {}) => {
    const response = await axiosInstance.get('/api/activity/tasks/stats', { params });
    return response.data;
  },

  getMyTasks: async (params = {}) => {
    const response = await axiosInstance.get('/api/activity/tasks/my-tasks', { params });
    return response.data;
  },

  create: async (data) => {
    const response = await axiosInstance.post('/api/activity/tasks', data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await axiosInstance.put(`/api/activity/tasks/${id}`, data);
    return response.data;
  },

  complete: async (id) => {
    const response = await axiosInstance.put(`/api/activity/tasks/${id}/complete`);
    return response.data;
  },

  delete: async (id) => {
    const response = await axiosInstance.delete(`/api/activity/tasks/${id}`);
    return response.data;
  },

  createReminder: async (taskId, data) => {
    const response = await axiosInstance.post(`/api/activity/tasks/${taskId}/reminders`, data);
    return response.data;
  },

  deleteReminder: async (taskId, reminderId) => {
    const response = await axiosInstance.delete(`/api/activity/tasks/${taskId}/reminders/${reminderId}`);
    return response.data;
  }
};

// ==================== CALENDAR SERVICE ====================
export const calendarService = {
  getConnections: async () => {
    const response = await axiosInstance.get('/api/activity/calendar/connections');
    return response.data;
  },

  connect: async (data) => {
    const response = await axiosInstance.post('/api/activity/calendar/connect', data);
    return response.data;
  },

  oauthCallback: async (data) => {
    const response = await axiosInstance.post('/api/activity/calendar/oauth-callback', data);
    return response.data;
  },

  disconnect: async (connectionId) => {
    const response = await axiosInstance.delete(`/api/activity/calendar/connections/${connectionId}`);
    return response.data;
  },

  sync: async (connectionId) => {
    const response = await axiosInstance.post(`/api/activity/calendar/connections/${connectionId}/sync`);
    return response.data;
  },

  getEvents: async (params = {}) => {
    const response = await axiosInstance.get('/api/activity/calendar/events', { params });
    return response.data;
  },

  createEvent: async (data) => {
    const response = await axiosInstance.post('/api/activity/calendar/events', data);
    return response.data;
  },

  updateEvent: async (id, data) => {
    const response = await axiosInstance.put(`/api/activity/calendar/events/${id}`, data);
    return response.data;
  },

  deleteEvent: async (id) => {
    const response = await axiosInstance.delete(`/api/activity/calendar/events/${id}`);
    return response.data;
  }
};

// ==================== BOOKING PAGE SERVICE ====================
export const bookingPageService = {
  getAll: async (params = {}) => {
    const response = await axiosInstance.get('/api/activity/booking-pages', { params });
    return response.data;
  },

  getById: async (id) => {
    const response = await axiosInstance.get(`/api/activity/booking-pages/${id}`);
    return response.data;
  },

  create: async (data) => {
    const response = await axiosInstance.post('/api/activity/booking-pages', data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await axiosInstance.put(`/api/activity/booking-pages/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await axiosInstance.delete(`/api/activity/booking-pages/${id}`);
    return response.data;
  },

  getPublicPage: async (bookingUuid) => {
    const response = await axiosInstance.get(`/api/public/activity/book/${bookingUuid}`);
    return response.data;
  },

  getAvailableSlots: async (bookingUuid, params = {}) => {
    const response = await axiosInstance.get(`/api/public/activity/book/${bookingUuid}/slots`, { params });
    return response.data;
  },

  createBooking: async (bookingUuid, data) => {
    const response = await axiosInstance.post(`/api/public/activity/book/${bookingUuid}`, data);
    return response.data;
  }
};

// ==================== EMAIL SYNC SERVICE ====================
export const emailSyncService = {
  getConfigs: async () => {
    const response = await axiosInstance.get('/api/activity/email-sync/configs');
    return response.data;
  },

  setup: async (data) => {
    const response = await axiosInstance.post('/api/activity/email-sync/setup', data);
    return response.data;
  },

  disconnect: async (configId) => {
    const response = await axiosInstance.delete(`/api/activity/email-sync/configs/${configId}`);
    return response.data;
  },

  getEmailLogs: async (params = {}) => {
    const response = await axiosInstance.get('/api/activity/email-logs', { params });
    return response.data;
  }
};

// ==================== COMMUNICATION SERVICE ====================
export const communicationService = {
  getSmsLogs: async (params = {}) => {
    const response = await axiosInstance.get('/api/activity/sms-logs', { params });
    return response.data;
  },

  logSms: async (data) => {
    const response = await axiosInstance.post('/api/activity/sms-logs', data);
    return response.data;
  },

  getCallLogs: async (params = {}) => {
    const response = await axiosInstance.get('/api/activity/call-logs', { params });
    return response.data;
  },

  logCall: async (data) => {
    const response = await axiosInstance.post('/api/activity/call-logs', data);
    return response.data;
  },

  getStats: async (params = {}) => {
    const response = await axiosInstance.get('/api/activity/communication-stats', { params });
    return response.data;
  }
};

export default {
  task: taskService,
  calendar: calendarService,
  bookingPage: bookingPageService,
  emailSync: emailSyncService,
  communication: communicationService
};
